const statusColors = {
    new: '#d9ead3',
    work: '#ffffff',
    end: '#efefef',
}

export default statusColors